import 'react-datepicker/dist/react-datepicker.css';
import './custom-datepicker.css';

import { useField } from 'formik';
import React from 'react';
import DatePicker from 'react-datepicker';

import styled from '@emotion/styled';

export const CustomDatePicker: React.FC<any> = ({
  label,
  placeholder,
  className,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);

  const handleChange = (date: any) => {
    helpers.setValue(date);
  };

  return (
    <InputWrapper className={className}>
      <InputContainer>
        <InputLabel htmlFor={props.name || props.id}>{label}</InputLabel>
        <DatePicker
          className="custom-datepicker"
          {...field}
          {...props}
          placeholderText={placeholder}
          selected={field.value || null}
          onChange={handleChange}
        />
        <RightPlaceHolderCardIcon
          alt="icon"
          src={'/static/svg/calenderIcon.svg'}
        />
      </InputContainer>
      {meta.touched && meta.error ? (
        <FieldErrorInfo>{meta.error}</FieldErrorInfo>
      ) : null}
    </InputWrapper>
  );
};

export default CustomDatePicker;

export const FieldErrorInfo = styled.div`
  font-size: 0.8rem;
  color: red;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;

export const InputLabel = styled.label`
  font-weight: 400;
  font-size: 1rem;
  color: ${({ theme }) => theme.palette.tertiaryText};
`;

export const InputContainer = styled.div`
  display: grid;
  height: fit-content;

  & > * {
    grid-column: 1;
    grid-row: 1;
  }
  &:hover {
    cursor: pointer;
  }
`;

export const RightPlaceHolderCardIcon = styled.img`
  height: 1.5rem;
  display: grid;
  margin-right: 1rem;
  margin-left: auto;
  margin-top: 1rem;
  z-index: 1;
`;
